module.exports = __webpack_public_path__ + "static/media/work-with-a-coach.375d366b.svg";